module.exports = __webpack_public_path__ + "img/icon2.3ef7937e.png";